import React, { useState, useEffect } from "react";
import { Container, Form, Row, Col, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { getDocumentTypeData, saveDocumentType } from "../Api/Reconciliation";

const BankRecoDocType = () => {
  const [docTypes, setDocTypes] = useState([]);
  const [formData, setFormData] = useState({
    docType: "",
    matchingDocType: "",
    PostedGl: "",
    MatchingGl: "",
    PostedPk: "",
    MatchingPk: "",
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchDocTypes = async () => {
      try {
        const response = await getDocumentTypeData();
        setDocTypes(response || []);
      } catch (error) {
        toast.error("Failed to load document types");
      }
    };
    fetchDocTypes();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.docType || !formData.matchingDocType) {
      toast.error("Please select both Doc Type and Matching Doc Type");
      return;
    }

    const payload = {
      docType: formData.docType, // only code
      matchingDocType: formData.matchingDocType, // only code
      PostedGl: formData.PostedGl,
      MatchingGl: formData.MatchingGl,
      PostedPk: formData.PostedPk,
      MatchingPk: formData.MatchingPk,
    };
    console.log("Saving Document Type:", payload);

    try {
      setLoading(true);
      await saveDocumentType(payload);
      toast.success("Document Type saved successfully ✅");
      setFormData({
        docType: "",
        matchingDocType: "",
        PostedGl: "",
        MatchingGl: "",
        PostedPk: "",
        MatchingPk: "",
      });
    } catch (error) {
      toast.error(error.message || "Failed to save document type ❌");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="main-content expand">
      <Container fluid className="fields-container">
        <h2 className="fields-title">Bank Reconciliation Document Type</h2>
        <Form className="fields-form" onSubmit={handleSubmit}>
          <Row>
            {/* DocType Dropdown */}
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>
                  Doc Type <span className="text-red">**</span>
                </Form.Label>
                <Form.Select
                  name="docType"
                  value={formData.docType}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Doc Type</option>
                  {docTypes.map((item, idx) => (
                    <option key={idx} value={item.code}>
                      {item.code} - {item.description}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>

            {/* Matching DocType Dropdown */}
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>
                  Matching Doc Type <span className="text-red">**</span>
                </Form.Label>
                <Form.Select
                  name="matchingDocType"
                  value={formData.matchingDocType}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Matching Doc Type</option>
                  {docTypes.map((item, idx) => (
                    <option key={idx} value={item.code}>
                      {item.code} - {item.description}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            {/* PostedGl */}
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>PostedGl</Form.Label>
                <Form.Control
                  type="text"
                  name="PostedGl"
                  value={formData.PostedGl}
                  onChange={handleChange}
                  placeholder="Enter PostedGl"
                />
              </Form.Group>
            </Col>

            {/* MatchingGl */}
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>MatchingGl</Form.Label>
                <Form.Control
                  type="text"
                  name="MatchingGl"
                  value={formData.MatchingGl}
                  onChange={handleChange}
                  placeholder="Enter MatchingGl"
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            {/* PostedPk */}
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>PostedPk</Form.Label>
                <Form.Control
                  type="text"
                  name="PostedPk"
                  value={formData.PostedPk}
                  onChange={handleChange}
                  placeholder="Enter PostedPk"
                />
              </Form.Group>
            </Col>

            {/* MatchingPk */}
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>MatchingPk</Form.Label>
                <Form.Control
                  type="text"
                  name="MatchingPk"
                  value={formData.MatchingPk}
                  onChange={handleChange}
                  placeholder="Enter MatchingPk"
                />
              </Form.Group>
            </Col>
          </Row>

          <div className="fields-btn-container">
            <Button
              type="submit"
              variant="primary"
              className="fields-submit"
              disabled={loading}
            >
              {loading ? "Saving..." : "Save Document Type"}
            </Button>
          </div>
        </Form>
      </Container>
    </div>
  );
};

export default BankRecoDocType;

// import React, { useState, useEffect } from "react";
// import { Container, Form, Row, Col, Button } from "react-bootstrap";
// import { toast } from "react-toastify";
// import { getDocumentTypeData, saveDocumentType } from "../Api/Reconciliation";

// const BankRecoDocType = () => {
//   const [docTypes, setDocTypes] = useState([]);
//   const [formData, setFormData] = useState({
//     docType: "",
//     matchingDocType: "",
//   });
//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     const fetchDocTypes = async () => {
//       try {
//         const response = await getDocumentTypeData();
//         setDocTypes(response || []);
//       } catch (error) {
//         toast.error("Failed to load document types");
//       }
//     };
//     fetchDocTypes();
//   }, []);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!formData.docType || !formData.matchingDocType) {
//       toast.error("Please select both Doc Type and Matching Doc Type");
//       return;
//     }

//     const payload = {
//       docType: formData.docType, // only code
//       matchingDocType: formData.matchingDocType, // only code
//     };
//     console.log("Saving Document Type:", payload);

//     try {
//       setLoading(true);
//       await saveDocumentType(payload);
//       toast.success("Document Type saved successfully ✅");
//       setFormData({ docType: "", matchingDocType: "" }); // reset
//     } catch (error) {
//       toast.error(error.message || "Failed to save document type ❌");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="main-content expand">
//       <Container fluid className="fields-container">
//         <h2 className="fields-title">Bank Reconciliation Document Type</h2>
//         <Form className="fields-form" onSubmit={handleSubmit}>
//           <Row>
//             {/* DocType Dropdown */}
//             <Col md={6}>
//               <Form.Group className="mb-3">
//                 <Form.Label>
//                   Doc Type <span className="text-red">**</span>
//                 </Form.Label>
//                 <Form.Select
//                   name="docType"
//                   value={formData.docType}
//                   onChange={handleChange}
//                   required
//                 >
//                   <option value="">Select Doc Type</option>
//                   {docTypes.map((item, idx) => (
//                     <option key={idx} value={item.code}>
//                       {item.code} - {item.description}
//                     </option>
//                   ))}
//                 </Form.Select>
//               </Form.Group>
//             </Col>

//             {/* Matching DocType Dropdown */}
//             <Col md={6}>
//               <Form.Group className="mb-3">
//                 <Form.Label>
//                   Matching Doc Type <span className="text-red">**</span>
//                 </Form.Label>
//                 <Form.Select
//                   name="matchingDocType"
//                   value={formData.matchingDocType}
//                   onChange={handleChange}
//                   required
//                 >
//                   <option value="">Select Matching Doc Type</option>
//                   {docTypes.map((item, idx) => (
//                     <option key={idx} value={item.code}>
//                       {item.code} - {item.description}
//                     </option>
//                   ))}
//                 </Form.Select>
//               </Form.Group>
//             </Col>
//           </Row>

//           <div className="fields-btn-container">
//             <Button
//               type="submit"
//               variant="primary"
//               className="fields-submit"
//               disabled={loading}
//             >
//               {loading ? "Saving..." : "Save Document Type"}
//             </Button>
//           </div>
//         </Form>
//       </Container>
//     </div>
//   );
// };

// export default BankRecoDocType;
